var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('FilterFields', {
    attrs: {
      "fields": [{
        type: 'text',
        label: 'Número',
        field: 'numero'
      }, {
        type: 'date',
        label: 'Data de Jornada',
        field: 'data_jornada'
      }, {
        type: 'date',
        label: 'Data de Emissão',
        field: 'data_emissao'
      }, {
        type: 'text',
        label: 'Motorista',
        field: 'motorista'
      }, {
        type: 'text',
        label: 'Veículo',
        field: 'veiculo'
      }, {
        type: 'select',
        label: 'Status',
        field: 'status',
        options: ['Todos', 'Autorizado', 'Cancelado', 'Editando', 'Rejeitado', 'Encerrado', 'Em processamento']
      }]
    }
  }), _c('TableApp', {
    ref: "mdfeList",
    attrs: {
      "titulo": "MDFe",
      "acaoBtn": "/#/mdfe/nova-mdfe",
      "textoBtn": "Nova MDFe",
      "api-url": "/mdfe/lista",
      "fields": _vm.fields,
      "classFilterColumn": "numero",
      "perPage": 10
    },
    scopedSlots: _vm._u([{
      key: "customRow",
      fn: function fn(props) {
        return [props.field == 'numero' ? _c('span', {
          staticClass: "pl-0 pt-8",
          attrs: {
            "slot": "numero"
          },
          slot: "numero"
        }, [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('div', {
          staticClass: "font-weight-bold text-muted"
        }, [_vm._v(" " + _vm._s(props.rowData.numero) + " ")])])]) : _vm._e(), props.field == 'status' ? _c('span', {
          class: _vm.statusMdfeClass(props.rowData.status),
          attrs: {
            "slot": "status"
          },
          slot: "status"
        }, [_vm._v(" " + _vm._s(_vm.statusMdfeLabel(props.rowData.status)) + " ")]) : _vm._e(), props.field == 'data_jornada' ? _c('span', {
          staticClass: "pl-0 pt-8",
          attrs: {
            "slot": "valor"
          },
          slot: "valor"
        }, [_c('div', {
          staticClass: "d-flex align-items-center justify-content-end font-weight-bold text-muted"
        }, [_vm._v(" " + _vm._s(_vm._f("moment")(props.rowData.data_jornada, "DD/MM/YYYY")) + " ")])]) : _vm._e(), props.field == 'data_emissao' ? _c('span', {
          staticClass: "pl-0 pt-8",
          attrs: {
            "slot": "valor"
          },
          slot: "valor"
        }, [_c('div', {
          staticClass: "d-flex align-items-center justify-content-end font-weight-bold text-muted"
        }, [_vm._v(" " + _vm._s(_vm._f("moment")(props.rowData.data_emissao, "DD/MM/YYYY")) + " ")])]) : _vm._e(), props.field == 'motorista' ? _c('span', {
          staticClass: "pl-0 pt-8",
          attrs: {
            "slot": "valor"
          },
          slot: "valor"
        }, [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('div', {
          staticClass: "font-weight-bold text-muted"
        }, [_vm._v(" " + _vm._s(_vm.lerJsonMotorista(props.rowData.dados)) + " ")])])]) : _vm._e(), props.field == 'veiculo' ? _c('span', {
          staticClass: "pl-0 pt-8",
          attrs: {
            "slot": "valor"
          },
          slot: "valor"
        }, [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('div', {
          staticClass: "font-weight-bold text-muted"
        }, [_vm._v(" " + _vm._s(_vm.lerJsonVeiculo(props.rowData.dados)) + " ")])])]) : _vm._e(), props.field == 'actions' ? _c('span', {
          attrs: {
            "slot": "actions"
          },
          slot: "actions"
        }, [_c('div', {
          staticClass: "row-actions",
          staticStyle: {
            "text-align": "right !important"
          }
        }, [_c('span', {
          staticStyle: {
            "overflow": "visible"
          }
        }, [_c('div', {
          staticClass: "action-buttons"
        }, [props.rowData.status === 1 || props.rowData.status === 6 ? _c('button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.bottom",
            value: 'Editar MDFe',
            expression: "'Editar MDFe'",
            modifiers: {
              "bottom": true
            }
          }],
          staticClass: "btn btn-sm btn-info btn-hover-info btn-icon mr-2",
          on: {
            "click": function click($event) {
              return _vm.handleEditMdfe(props.rowData);
            }
          }
        }, [_c('Pencil', {
          attrs: {
            "size": 16
          }
        })], 1) : _vm._e(), props.rowData.status === 2 ? _c('button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.bottom",
            value: 'Cancelar MDFe',
            expression: "'Cancelar MDFe'",
            modifiers: {
              "bottom": true
            }
          }],
          staticClass: "btn btn-sm btn-danger btn-icon mr-2",
          on: {
            "click": function click($event) {
              return _vm.cancelMdfe(props.rowData);
            }
          }
        }, [_c('Close', {
          attrs: {
            "size": 20
          }
        })], 1) : _vm._e(), props.rowData.status === 2 || props.rowData.status === 4 || props.rowData.status === 3 || props.rowData.status === 6 ? _c('button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.bottom",
            value: 'Consultar MDFe',
            expression: "'Consultar MDFe'",
            modifiers: {
              "bottom": true
            }
          }],
          staticClass: "btn btn-sm btn-warning btn-icon mr-2",
          on: {
            "click": function click($event) {
              return _vm.consultarMdfe(props.rowData);
            }
          }
        }, [_c('Search', {
          attrs: {
            "size": 20
          }
        })], 1) : _vm._e(), props.rowData.status === 2 || props.rowData.status === 4 ? _c('button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.bottom",
            value: 'Gerar Pdf',
            expression: "'Gerar Pdf'",
            modifiers: {
              "bottom": true
            }
          }],
          staticClass: "btn btn-sm btn-info btn-hover-info btn-icon mr-2",
          on: {
            "click": function click($event) {
              return _vm.imprimirPDF(props.rowData);
            }
          }
        }, [_c('PdfIcon', {
          attrs: {
            "size": 22
          }
        })], 1) : _vm._e(), _c('button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: props.rowData.status == 1,
            expression: "props.rowData.status == 1"
          }, {
            name: "b-tooltip",
            rawName: "v-b-tooltip.bottom",
            value: 'Transmitir MDFe',
            expression: "'Transmitir MDFe'",
            modifiers: {
              "bottom": true
            }
          }],
          staticClass: "btn btn-sm btn-info btn-icon mr-2",
          on: {
            "click": function click($event) {
              return _vm.transmitir(props.rowData);
            }
          }
        }, [_c('TransmitIcon', {
          attrs: {
            "size": 16
          }
        })], 1), _c('button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: props.rowData.status == 2,
            expression: "props.rowData.status == 2"
          }, {
            name: "b-modal",
            rawName: "v-b-modal.encerrarMdfe",
            modifiers: {
              "encerrarMdfe": true
            }
          }, {
            name: "b-tooltip",
            rawName: "v-b-tooltip.bottom",
            value: 'Encerrar MDFe',
            expression: "'Encerrar MDFe'",
            modifiers: {
              "bottom": true
            }
          }],
          staticClass: "btn btn-sm btn-success btn-icon mr-2",
          on: {
            "click": function click($event) {
              return _vm.selectMdfe(props.rowData.id_mdfe);
            }
          }
        }, [_c('PackageCheck', {
          attrs: {
            "size": 16
          }
        })], 1), props.rowData.arquivo_xml !== null ? _c('button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.bottom",
            value: 'Gerar XML',
            expression: "'Gerar XML'",
            modifiers: {
              "bottom": true
            }
          }],
          staticClass: "btn btn-sm btn-info btn-hover-info btn-icon mr-2",
          on: {
            "click": function click($event) {
              return _vm.gerarlXml(props.rowData);
            }
          }
        }, [_c('XmlIcon', {
          attrs: {
            "size": 22
          }
        })], 1) : _vm._e()])])])]) : _vm._e()];
      }
    }])
  }), _c('b-modal', {
    attrs: {
      "id": "encerrarMdfe",
      "title": "Encerrar MDFe",
      "centered": ""
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn(_ref) {
        var _this = this;
        var ok = _ref.ok,
          cancel = _ref.cancel;
        return [_c('b-button', {
          ref: "encerrar_mdfe",
          attrs: {
            "variant": "primary"
          },
          on: {
            "click": _vm.encerrarMdfe
          }
        }, [_vm._v(" Encerrar ")]), _c('b-button', {
          on: {
            "click": function click() {
              cancel();
              _this.selectMdfe = null;
            }
          }
        }, [_vm._v(" Cancelar ")])];
      }
    }])
  }, [_c('b-form', {
    staticClass: "form"
  }, [_c('b-row', {
    attrs: {
      "align-h": "center"
    }
  }, [_c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "uf_encerramento",
      "label-for": "uf_encerramento",
      "label": "UF de encerramento"
    }
  }, [_c('VueSelect', {
    ref: "uf_encerramento",
    attrs: {
      "filterable": false,
      "options": _vm.ufsSearched
    },
    on: {
      "search": _vm.searchUf
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-center"
        }, [_vm._v(" " + _vm._s(option.sigla) + " ")])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.sigla) + " ")])];
      }
    }]),
    model: {
      value: _vm.ufSelected,
      callback: function callback($$v) {
        _vm.ufSelected = $$v;
      },
      expression: "ufSelected"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Informe a UF ")])], 2)], 1)], 1), _c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "cidadeEncerramento",
      "label-for": "cidadeEncerramento",
      "label": "Cidade de encerramento"
    }
  }, [_c('VueSelect', {
    ref: "cidadeEncerramento",
    attrs: {
      "filterable": false,
      "options": _vm.cidades
    },
    on: {
      "search": _vm.onSearchCidades
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-center"
        }, [_vm._v(" " + _vm._s(option.cidade) + " ")])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.cidade) + " ")])];
      }
    }]),
    model: {
      value: _vm.cidadeEncerramento,
      callback: function callback($$v) {
        _vm.cidadeEncerramento = $$v;
      },
      expression: "cidadeEncerramento"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Informe o nome da cidade ")])], 2)], 1)], 1)], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };